<template>
    <router-link :to="data.link" class="text-decoration-none1">
        <div class="card mb-3 border-0 rounded-4">
            <div class="row g-0">
                <div class="col-md-5">
                    <div class="blog-item-image position-relative" :style="`background: url(${data.image}) no-repeat left center; background-size: cover; height: 220px;`"></div>
                </div>
                <div class="col-md-7">
                    <div class="card-body py-2 px-3 h-100 d-flex justify-content-between flex-column">
                        <h5 class="card-title">{{ data.translate[0].firstname }} {{ data.translate[0].lastname }}</h5>
                        <p class="card-text mb-auto">
                            {{ G.stripTags(data.about || '').substring(0, 220) + '...' }}
                        </p>
                        <a :href="`mailto:${data.email}`" class="text-secondary"><i class="far fa-envelope me-2"></i>{{ data.email }}</a>
                        {{ data.last_post.create_date }}
                        <div class="card-text text-secondary small d-flex justify-content-between align-items-center mb-2">
                            <div class="card-text">{{ lang.last_post }}: {{ data.last_post.create_date ? data.last_post.create_date : '' }}</div>
                            <div class="fw-bold">
                                {{ lang.posts }}:
                                <!-- <i class="fas fa-edit"></i> -->
                                {{ data.post_count.length }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </router-link>

</template>


<script>
// import { useRouter } from 'vue-router';

import { G } from "@/_common";

export default {
    name: "CardHC",
    props:{
        data: {
            type: Object,
            default: () => {}
        },
        lang: {
            type: Object,
            default: () => {}
        },
    },
    setup() {
        // const router = useRouter();

        return {
            G,
        };
    },
}
</script>


<style lang="scss">
.post-meta {
    font-size: 0.8rem;
    color: var(--muted-text-color);
}
// .read-more-btn {
//     background-color: rgb(var(--site-primary-color-rgb));
//     color: white;
//     padding: 8px 15px;
//     border-radius: 10px;
//     font-size: 0.8rem;
//     text-decoration: none;
// }
.blog-item-image{
    border-radius: 1rem 0 0 1rem;
}
.blog-item-footer .btn:active{
    border: 0px;
    border-bottom: 1px solid black;
    border-radius: 0;
}

@media (max-width: 576px){
    .blog-item-image{
        border-radius: 1rem 1rem 0 0;
    }
}
</style>